import {Fragment} from 'react';
import {Venue} from '../venue/venue';
import css from './venues.module.scss';
import {VenuesProps} from './venues.types';

export const Venues = ({list, height, onVenueSelect}: VenuesProps) => {
	return (
		<div style={{height}} className={css.container}>
			{list.map((venue) => (
				<Fragment key={venue.date}>
					<div onClick={() => onVenueSelect(venue.date)}>
						<Venue key={venue.date} {...venue} />
					</div>
					<div className={css.divider}></div>
				</Fragment>
			))}
		</div>
	);
};
